const getFormatedPrice = (price) => {
  const parts = price.toString().split(".");
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formattedPrice =
    parts.length > 1 ? `${integerPart}.${parts[1]}` : integerPart;
  return formattedPrice + " MAD";
};

export default getFormatedPrice;
